var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.007,
    height: 49,
    viewBox: "0 0 48.007 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment",
    transform: "translate(-0.111 0.425)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6825",
    "data-name": "Group 6825",
    transform: "translate(0 83.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1217",
    "data-name": "Ellipse 1217",
    cx: 24,
    cy: 24.5,
    rx: 24,
    ry: 24.5,
    transform: "translate(0.111 -83.925)",
    fill: "#53b3cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15096",
    "data-name": "Path 15096",
    d: "M168.166,85.186c0-.967-6.336-7.008-9.34-9.648l-9.975.543-4.741-3.839-1.633,8.417-16.111,2.936,11.471,25.368a24.167,24.167,0,0,0,30.329-23.776Z",
    transform: "translate(-120.048 -144.769)",
    fill: "#3f9eb5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heart_4_",
    "data-name": "heart (4)",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 2.192, 14.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6795",
    "data-name": "Group 6795",
    transform: "translate(1.094 1.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15060",
    "data-name": "Path 15060",
    d: "M17.307,32.825C16.489,30.535,5.621,22.807,1.7,14.957a11,11,0,0,1-.735-10.3A8.744,8.744,0,0,1,11.587.646a8.309,8.309,0,0,1,4.739,3.721A9.343,9.343,0,0,1,23.394.033,9.455,9.455,0,0,1,31.157,3.1c2.656,2.985,3.064,7.483,1.8,11.244s-4,6.665-6.987,9.322c-1.675,1.513-3.514,3.107-5.066,4.743s-3.105,2.9-3.555,5.07",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796",
    transform: "translate(2.447 5.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15061",
    "data-name": "Path 15061",
    d: "M15.963,28.755C15.153,26.78,5.387,19.97,1.5,13.078c-.729-1.33-2.512-3.1-.729-8.785C1.133,3.084,3.645-1.228,10.047.545c1.986.564,3.566,2.176,4.944,4.03C16.49,2.439,19.165.223,22,.021a9.775,9.775,0,0,1,7.456,2.942c2.634,2.619,1.783,6.287.527,9.591s-2.472,5.843-5.43,8.181c-1.661,1.33-3.485,2.74-5.025,4.151C17.99,26.337,16.45,27.425,16,29.36",
    fill: "#f1afad"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15062",
    "data-name": "Path 15062",
    d: "M6.386,9.493a79.352,79.352,0,0,0,8.681,9.173,1.531,1.531,0,0,0,.852.411,1.5,1.5,0,0,0,1.339-.5c3.489-3.605,7.1-6.48,10.385-10.4A46.614,46.614,0,0,0,31.5,2.191c-.162.456-1.258,4.837-1.5,5.248C26.548,13.828,21.03,18.209,16.974,24.1c-.2.274-.446.639-.771.548a.944.944,0,0,1-.487-.365C12.187,20.172,8.7,15.928,5.29,11.638a28.619,28.619,0,0,1-2.8-3.925A19.645,19.645,0,0,1,.3,2.055C.219,1.6-.308-.045.26,0c.284.046,3.164,5.7,6.126,9.492Z",
    transform: "translate(2.471 8.634)",
    fill: "#e09b9c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6798",
    "data-name": "Group 6798",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15063",
    "data-name": "Path 15063",
    d: "M27.017.1a10.558,10.558,0,0,0-9.423,3.58A10.36,10.36,0,0,0,7.43.386a9.462,9.462,0,0,0-6.46,5.1c-3.621,8.477,3.662,16.418,9.3,21.891,1.564,1.523,3.21,2.963,4.856,4.4a12.283,12.283,0,0,1,2.716,2.551c-.041.082-.041.165-.082.206a.893.893,0,0,0,1.728.453c.494-2.057,2.057-3.415,3.5-4.9,1.564-1.6,3.251-3.127,4.9-4.609,2.88-2.592,5.473-5.308,7.078-8.888,3-6.707-.082-15.39-7.942-16.5ZM33.6,14.171c-.864,4.362-4.074,7.613-7.242,10.452-1.852,1.646-3.621,3.292-5.349,5.061a15.8,15.8,0,0,0-2.387,2.922,25.13,25.13,0,0,0-3.745-4.033,106.077,106.077,0,0,1-8.065-8.6c-1.893-2.387-3.95-5.432-4.362-8.559A7.768,7.768,0,0,1,5.661,3.76a7.466,7.466,0,0,1,5.267-1.193,7.941,7.941,0,0,1,5.637,3.58,1.176,1.176,0,0,0,2.016,0A8.3,8.3,0,0,1,29.774,3.513c3.7,2.222,4.609,6.707,3.827,10.658Z",
    fill: "#3f9eb5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797",
    transform: "translate(19.41 7.158)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15064",
    "data-name": "Path 15064",
    d: "M6.247.511C8.072,5.075,4.193,10.369.634,12.833a1.272,1.272,0,0,0-.456,1.688c.046.091.137.183.183.274a1.281,1.281,0,0,0,1.78,0A16.192,16.192,0,0,0,7.57,6.672c.548-2.054.776-4.655-.548-6.48C6.795-.173,6.064.009,6.247.511Z",
    transform: "translate(3.245 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15065",
    "data-name": "Path 15065",
    d: "M2.921,1.323A1.533,1.533,0,0,0,2.692.685,1.362,1.362,0,0,0,1.506,0,1.378,1.378,0,0,0,.091,1.05v.137A1.35,1.35,0,0,0,0,1.643a1.335,1.335,0,0,0,.365.867,1.531,1.531,0,0,0,1.825.319A1.475,1.475,0,0,0,2.921,1.323Z",
    transform: "translate(0 14.887)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.f89a24c6.svg";
export { ForwardRef as ReactComponent };